import { createComponent } from '@carvana/merch-components';
import { PrimaryButton } from '@/Button';

export const DefaultInput = createComponent('div', {
  className:
    'bg-grey-1 flex h-[52px] items-center justify-center rounded w-[140px] m:max-w-[300px] m:w-full'
});

export const Container = createComponent('div', {
  className: 'flex flex-col gap-16'
});

export const Header = createComponent('h2', {
  className: ' flex-shrink-0 t-header-s text-blue-6'
});

export const SubText = createComponent('p', {
  className: 't-body-m text-grey-5'
});

export const ExpiredPill = createComponent('div', {
  className:
    'bg-yellow-2 flex items-center px-8 rounded-xl t-label-xs text-black'
});

export const PaymentInputWrapper = createComponent('div', {
  className:
    'grid grid-cols-2 items-center justify-between l:flex l:flex-col l:gap-8 l:items-start'
});

export const ExpiredCard = createComponent('div', {
  className: 'bg-yellow-1 p-16 rounded-md t-body-s text-blue-6'
});

export const SoftPullCTA = createComponent(PrimaryButton, {
  className: '!h-[40px] !min-h-[40px]'
});

export const GreyBar = createComponent('div', {
  className: 'border-grey-2 border-t my-16 w-full'
});

export const MiniGreyBar = createComponent('div', {
  className: 'border-grey-2 border-t hidden w-full l:block'
});

export const ErrorText = createComponent('p', {
  className: 'leading-4 t-body-xs text-red-2'
});

export const InputErrorWrapper = createComponent('div', {
  className: 'flex flex-col gap-4'
});
